module.exports = __webpack_public_path__ + "img/58_1.e68d54f7.png";